<!-- eslint-disable -->
<template lang="pug">
    .back-to-battle
        .back-to-battle__content
            svg-icon.back-to-battle__icon(name="bell", aria-hidden="true", height="50", width="50")
            .back-to-battle__text(v-html="$i18n.t('battle.battle_opponent_waiting')")
            .back-to-battle__time-left
                div(v-if="time > 0") {{ getTime }}
                cs-loader.back-to-battle__loader(v-else size="base")
            button.button.button__back(@click="reconnectToBattle") {{ $i18n.t('battle.battle_back') }}
</template>

<script>
    /*eslint-disable*/

    import BattleApi from '../../api/battle';
    import timer from '../../utils/trainer/timer';

    export default {

        mixins: [timer],

        data() {
            return {
                battleId: null,
                opponent: null,
                pauseStageIndex: null,
                pauseGameIndex: null,
                pauseUserScore: null,
                pauseOpponentScore: null,
                time: null
            }
        },
        watch: {
            time: {
                handler(value) {
                    if (value === 0) {
                        this.resetTimer();
                        this.$store.dispatch('setBattlePaused', null);
                    }
                }
            }
        },
        mounted () {
            this.getReconnectStatus();
            document.addEventListener('visibilitychange', this.handleFocusTab);
        },
        beforeDestroy() {
            document.removeEventListener('visibilitychange', this.handleFocusTab);
        },
        methods: {
            handleFocusTab() {
                if (!document.hidden) {
                    this.getReconnectStatus();
                }
            },
            reconnectToBattle() {
                BattleApi.resumeBattle()
                    .then(data => {
                        this.battleId = data.battleId;
                        this.opponent = data.opponent;
                        this.gameDone = data.gameDone;
                        this.$router.push({
                            name: 'battle:start',
                            params: {
                                id: this.battleId,
                                opponent: this.opponent,
                                gameDone: this.gameDone,
                                stageIndexOnBattleResume: this.pauseStageIndex,
                                gameIndexOnBattleResume: this.pauseGameIndex,
                                userScoreOnBattleResume: this.pauseUserScore,
                                opponentScoreOnBattleResume: this.pauseOpponentScore,
                            }
                        });
                    })
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                    });
                setTimeout(() => {BattleApi.updateActivity()}, 5000);
            },
            getReconnectStatus() {
                BattleApi.getReconnectStatus()
                    .then(data => {
                        this.resetTimer();
                        this.time = data.secondsLeftToReconnect;
                        this.pauseStageIndex = data.pauseStageIndex;
                        this.pauseGameIndex = data.pauseGameIndex;
                        this.pauseUserScore = data.userScore;
                        this.pauseOpponentScore = data.opponentScore;
                        this.setTimer();
                    })
                    .catch(err => {
                        if (err.status && err.status === 503) {
                            this.$toasted.error(err.message);
                        }
                    })
            },
            setTimer() {
                this.time = this.time - 1;
                this.timer = setTimeout(this.setTimer, 1000);
            },

        }
    }
</script>

<style scoped lang="scss">
    .back-to-battle {
        height: 100%;
        width: 100%;
        position: absolute;
        pointer-events: none;
    }
    .back-to-battle__content {
        pointer-events: all;
        min-width: 320px;
        max-width: 350px;
        height: 200px;
        margin: 0;
        @media screen and (min-width: 360px) {
            margin: 0 20px;
        }
        @include media($sm) {
            height: 200px;
            margin: 0 30px;
            padding: 30px;
        }
        background: #FFFFFF;
        box-shadow: 0 0 40px rgba(51, 51, 51, 0.4);
        border-radius: 40px;
        padding: 30px 15px;
        text-align: center;
        position: fixed;
        bottom: 0;
        top: 96.5vh;
        right: 35px;
        z-index: 3;
        transform: translateY(-100%);

        @media screen and (max-width: 575px) {
            height: 150px;
            right: 0;
            margin: 0;
        }
    }
    .back-to-battle__time-left {
        margin: 15px 0;
    }
    .back-to-battle__bell {
        margin: 0 auto;
        @media screen and (max-width: 575px) {
            display: none;
        }
    }
    .back-to-battle__icon {
        display: none;
        @include media($sm) {
            display: inline-flex;
        }
    }
    .back-to-battle__text {
        line-height: 24px;
        color: #333333;
        margin: 10px 0;
    }
    .back-to-battle__loader {
        height: 30px;
    }
    .button {
        height: auto;
        padding: 15px 30px;
        border-radius: 40px;
        color: #FFFFFF;
        border: 0;
    }
    .button__back {
        background: #6BBD6C;
    }
</style>
